import React, { useState } from 'react';
import './PasswordScreen.css';

function PasswordScreen({ onSubmit }) {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = onSubmit(password);
    if (!isValid) {
      setError(true);
      setTimeout(() => setError(false), 320);
    }
  };

  return (
    <div className="password-screen" data-testid="password-screen">
      <div className="password-container fade-in">
        <div className={`password-card ${error ? 'shake' : ''}`}>
          <h1 className="password-title">Willkommen</h1>
          <p className="password-subtitle">Alberto's Deluxe Timer</p>
          
          <form onSubmit={handleSubmit} className="password-form">
            <div className="input-group">
              <label htmlFor="password" className="input-label">
                Passwort
              </label>
              <div className="input-wrapper">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className={`password-input ${error ? 'error' : ''}`}
                  data-testid="password-input"
                  autoFocus
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="toggle-password"
                  data-testid="toggle-password"
                  aria-label={showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'}
                >
                  {showPassword ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <line x1="1" y1="1" x2="23" y2="23" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="12" cy="12" r="3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </button>
              </div>
              {error && (
                <span className="error-message" data-testid="error-message">
                  Falsches Passwort
                </span>
              )}
            </div>
            
            <button
              type="submit"
              className="submit-button"
              data-testid="submit-button"
            >
              Entsperren
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PasswordScreen;